import Directory from '@/components/directory';

export default Directory;
